<template>
	<div>
		<div class="white-bg">
			<div class="slantedDiv-TopRight">
				<section class="container page-content">
					<div class="row">
						<!-- Notifications database -->
						<div class="col-xs-12 col-sm-6 col-md-5 col-lg-5">
							<router-link to="/projects">
								<div class="nav-card-container">
									<div class="nav-card-title">
										Access the Project Database
									</div>
									<div class="nav-card-summary">
										Explore all available projects in the database.
									</div>
								</div>
							</router-link>
						</div>
						<!-- Advanced search -->
						<div
							class="col-xs-12 col-sm-6 col-md-5 col-md-offset-1 col-lg-5 col-lg-offset-1"
						>
							<router-link to="/search">
								<div class="nav-card-container">
									<div class="nav-card-title">
										Advanced Search
									</div>
									<div class="nav-card-summary">
										Search for specific projects with as many details as you
										have, including: project title, client, completion date,
										country or&nbsp;tags.
									</div>
								</div>
							</router-link>
						</div>
					</div>
					<hr class="hr-bold" />
					<!-- Latest updates -->
					<div class="row">
						<div class="col-xs-12">
							<div class="h2-lg">
								Latest Projects
							</div>
							<template v-if="loading">
								<div class="row">
									<div class="col-xs-12">
										<div class="container loading-container">
											<img
												class="section-loader"
												src="@/assets/images/fse_reg-section-loader-admin.gif"
											/>
										</div>
									</div>
								</div>
							</template>
							<template v-else-if="regulations && regulations.length > 0">
								<div
									v-for="regulation in regulations"
									:key="regulation.id"
									class="list-container list-container-projects"
								>
									<div class="row">
										<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
											<template v-if="regulation.clients.length > 0">
												<div class="sm-padding-bottom-10">
													<b-btn
														v-for="client in regulation.clients"
														:key="'a' + client.id"
														class="label label-success"
														@click="filterAndSearch('clients', client.id)"
													>
														&nbsp;{{ client.name }}&nbsp;
													</b-btn>
												</div>
											</template>
											<template v-else>
												<div class="sm-padding-bottom-10">
													<span class="label label-default"
														>No clients set</span
													>
												</div>
											</template>
											<div>
												{{ formatStartDate(regulation.start_date) }}
											</div>
										</div>
										<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
											<div class="sm-padding-bottom-10">
												<div class="notification-list-heading">
													<router-link :to="`/project/${regulation.id}`">
														{{ regulation.title }}
													</router-link>
												</div>
											</div>
										</div>
										<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
											<div>
												<b-btn
													v-for="region in regulation.regions"
													:key="'b' + region.id"
													class="label label-info"
													@click="filterAndSearch('regions', region.id)"
												>
													&nbsp;{{ region.name }}&nbsp;
												</b-btn>
												<!--
												<br />
												<b-btn
													v-for="tag in regulation.tags"
													:key="'c' + tag.id"
													class="label label-secondary"
													@click="filterAndSearch('tags', tag.id)"
												>
													&nbsp;{{ tag.name }}&nbsp;
												</b-btn>
												-->
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</section>
			</div>
		</div>
		<section class="pre-footer-bg"></section>
	</div>
</template>

<style lang="less" scoped>
.loading-container {
	text-align: center;
}
.section-loader {
	max-width: 200px;
	height: auto;
	margin: 30px auto;
}
</style>

<script>
import moment from 'moment';

export default {
	created() {
		this.getRegulations();
	},
	data() {
		return {
			title: 'Index',
			regulations: null,
			loading: false,
			selectedFilters: {
				regions: [],
				clients: [],
				status: [],
				dates: [],
				tags: [],
			},
		};
	},
	methods: {
		formatStartDate(startDate) {
			const date = moment(startDate).format('DD/MM/YYYY');

			if (date === 'Invalid date') {
				return 'In progress';
			}
			return `Completed: ${date}`;
		},
		async getRegulations() {
			this.loading = true;
			const {
				data: { data: regulations },
			} = await this.$axios.get('/resource', { params: { limit: 5, page: 1 } });
			this.$set(this, 'regulations', regulations);
			this.loading = false;
		},
		filterAndSearch(type, id) {
			this.$set(this.selectedFilters, type, [id]);
			this.$router.push({
				path: '/projects',
				query: {
					selectedFilters: this.selectedFilters,
				},
			});
		},
	},
};
</script>
